$(document).ready(function() {
    $.validator.addMethod('uniqueEmail', function(value, element) {
        var isSuccess = false;

        $.ajax({
            type: 'POST',
            url: $(document.body).data('base') + '/ajax/check-unique-email.php',
            async: false,
            data: 'email=' + value,
            success: function(exists) {
                isSuccess = (JSON.parse(exists) === 'true') ? false : true;
            }
        });

        return isSuccess;
    }, 'Email address already exists');

    $.validator.addMethod('matchedPassword', function(value, element) {
        var isSuccess = false;

        $.ajax({
            type: 'POST',
            url: $(document.body).data('base') + '/ajax/check-matched-passwords.php',
            async: false,
            data: 'confirm_password=' + value,
            success: function(exists) {
                isSuccess = (JSON.parse(exists) === 'true') ? false : true;
            }
        });

        return isSuccess;
    }, 'Passwords do no match');
});